export const GET_USER_TEMPLATES_REQUEST = 'GET_USER_TEMPLATES_REQUEST'
export const GET_USER_TEMPLATES_SUCCESS= 'GET_USER_TEMPLATES_SUCCESS'
export const GET_USER_TEMPLATES_FAIL = 'GET_USER_TEMPLATES_FAIL'
export const GET_USER_TEMPLATES_RESET = 'GET_USER_TEMPLATES_RESET'

export const GET_TEMPLATE_CONTENT_REQUEST = 'GET_TEMPLATE_CONTENT_REQUEST'
export const GET_TEMPLATE_CONTENT_SUCCESS = 'GET_TEMPLATE_CONTENT_SUCCESS'
export const GET_TEMPLATE_CONTENT_FAIL = 'GET_TEMPLATE_CONTENT_FAIL'
export const GET_TEMPLATE_CONTENT_RESET = 'GET_TEMPLATE_CONTENT_RESET'

export const CREATE_TEMPLATE_REQUEST = 'CREATE_TEMPLATE_REQUEST'
export const CREATE_TEMPLATE_SUCCESS = 'CREATE_TEMPLATE_SUCCESS'
export const CREATE_TEMPLATE_FAIL = 'CREATE_TEMPLATE_FAIL'
export const CREATE_TEMPLATE_RESET = 'CREATE_TEMPLATE_RESET'

export const UPDATE_TEMPLATE_REQUEST = 'UPDATE_TEMPLATE_REQUEST'
export const UPDATE_TEMPLATE_SUCCESS = 'UPDATE_TEMPLATE_SUCCESS'
export const UPDATE_TEMPLATE_FAIL = 'UPDATE_TEMPLATE_FAIL'
export const UPDATE_TEMPLATE_RESET = 'UPDATE_TEMPLATE_RESET'

export const DELETE_TEMPLATE_REQUEST = 'DELETE_TEMPLATE_REQUEST'
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS'
export const DELETE_TEMPLATE_FAIL = 'DELETE_TEMPLATE_FAIL'
export const DELETE_TEMPLATE_RESET = 'DELETE_TEMPLATE_RESET'